export default "__VITE_ASSET__wDQZWmar__"